module.exports = __webpack_public_path__ + "img/Alchimeia_island_raw.222b46ae.png";